import { Button, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from '@mui/material';
import { toTitleCase } from '../../../utils';
import { useContent } from '../../../logic';

interface CancelTaskDialogProps {
    open: boolean;
    setUserCancelOpen: (open: boolean) => void;
    onUserCancelTask: () => void;
    isSigningTask?: boolean;
}

export function CancelTaskDialog({ open, setUserCancelOpen, onUserCancelTask, isSigningTask }: CancelTaskDialogProps) {

  const { TaskText } = useContent()

  return <Dialog key="userCancel" open={open}>
    <DialogTitle>Cancel {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ mb: 1 }}>
                Are you sure you want to cancel this {TaskText}?
      </DialogContentText>
      {isSigningTask && (
        <DialogContentText>
                    After canceling, the {TaskText} will not be available to complete for your transaction.
        </DialogContentText>
      )}
    </DialogContent>

    <DialogActions>
      <Button variant="contained" onClick={() => setUserCancelOpen(false)}>
                No, keep it
      </Button>
      <Button variant="rounded" onClick={onUserCancelTask}>
                Yes, cancel it
      </Button>
    </DialogActions>
  </Dialog>
}
